module.exports = __webpack_public_path__ + "static/media/product-sales.b2526b9f.svg";